import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg'
import { ReactComponent as IconMenu } from '@/assets/svgs/menu-light.svg'
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg'
import MenuDropDown from '@/components/MenuDropDown'
import useModal from '@/hooks/use-modal/index'
import { useLocation, useNavigate } from '@/lib/router-dom'
import moment from 'moment'
import { Fragment, useState } from 'react'
import DeleteFolderModal from './delete-folder-modal.jsx'
import PinToTop from './pin-to-top.jsx'
import RenameFolderModal from './rename-folder-modal.jsx'

export default function FolderDataTable({ items,
	meta,
	pageLimit,
	currentPage,
	goToPrev,
	goToNext,
	setSortConfig,
	sortConfig,
	handleCurrnetInput,
}) {
	const { goTo } = useNavigate();
	const { currentPath } = useLocation();
	const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'

	const { visible: isShowRenameFolderModal, show: showRenameFolderModal, hide: hideRenameFolderModel } = useModal()
	const { visible: isShowDeleteFolderModal, show: showDeleteFolderModal, hide: hideDeleteFolderModal } = useModal()

	const [selectedRenameItem, setSelectedRenameItem] = useState('');
	const [selectedDeleteItem, setSelectedDeleteItem] = useState('');

	function getClassName(name) {
		if (!sortConfig) {
			return
		}
		return sortConfig.key === name ? (sortConfig.direction === true ? "is-asc" : "is-desc") : ""
	}


	function handleSort(key) {
		let direction = sortConfig.direction
		if (sortConfig.key === key) {
			direction = !direction
		} else {
			direction = true
		}

		const sortDirection = direction === true ? "ASC" : "DESC";

		setSortConfig({ key, direction })
	}

	const list = items?.map((item, index) => {
		return (
			<Fragment key={index}>
				<div className="data-table__table__body__row" key={index}>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__head__title--name">
						<div className='flex-center'>
						<PinToTop pinned={item.pinned} eclipFolderId={item.id} />
							{item.name || '---'}
						</div>
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--eclip-count">
						{String(item.eclipCount).padStart(2, '0')}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text">
						{moment(item.modified).format('DD/MM/yyyy, hh:mm a')}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__head__title--created">
						{moment(item.created).format('DD/MM/yyyy, hh:mm a')}
						{/* {moment(item.created).format('DD/MM/YYYY h:mma')} */}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end">
						<span className="data-table__table__body__content__action link tooltip"
							onClick={() => goTo(`/eclip/folder/${item.id}/${type}`)}
						>
							<span className="tooltiptext">View Details</span>
							<IconChevronRight />
						</span>
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--end">
						<MenuDropDown
							button={(props) => (
								<span className="eclip-landing_cursor-mode__pointer eclip-table--menu" {...props}>
									<IconMenu />
								</span>
							)}
							list={[
								{
									label: 'Rename',
									onClick: (e) => { e.stopPropagation(); setSelectedRenameItem(item); showRenameFolderModal() },
								},
								{
									label: 'Delete',
									onClick: (e) => { e.stopPropagation(); setSelectedDeleteItem(item); showDeleteFolderModal() },
								},
							]}
						/>
					</div>

				</div>
			</Fragment>
		)
	})

	function getPageStart(pageSize, pageNr) {
		return pageSize * pageNr;
	};

	const NoMessage = () => {
		return (
			<div className="data-table__empty__icon">
				<IconNoMessage />
			</div>
		)
	}

	function getPageLabel(total, pageSize, pageNr) {
		if(isNaN(pageNr)){
			pageNr = 0;
		}
		const start = Math.max(
			getPageStart(pageSize, pageNr),
			0
		);
		const end = Math.min(
			getPageStart(pageSize, pageNr + 1),
			total
		);

		return `${start + 1} - ${end}`;
	}



	return (
		<>
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div
										className={`data-table__table__head__title data-table__table__head__title--name data-table__table__head__title__sort-order link ${getClassName("name")}`}
										id="dataElementId" onClick={
											(e) => {
												handleSort('name')
											}
										}>
										Folder Name <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--eclip-count data-table__table__head__title__sort-order link ${getClassName("eclipCount")}`}
										id="orgId" onClick={
											(e) => {
												handleSort('eclipCount')
											}
										}>
										No.of Packages <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title--created data-table__table__head__title__sort-order link ${getClassName("modified")}`}
										id="modified" onClick={
											(e) => {
												handleSort('modified')
											}
										}>
										Modified on <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div
										className={`data-table__table__head__title data-table__table__head__title__sort-order link ${getClassName("created")}`}
										id="created" onClick={
											(e) => {
												handleSort('created')
											}
										}>
										Created on <span className="data-table__table__head__icon__sort-order"></span>
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--end">
										{/* Actions */}
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--end">
										{/* Actions */}
									</div>
								</div>
							</div>
							<div className="data-table__table__body">
								{list?.length > 0 ?
									list :
									<div className="data-table__empty"><NoMessage /></div>
								}
							</div>
							{
								list?.length > 0 && (
									<div className="data-table__table__footer" data-testid="datatable">
										<div className="data-table__table__footer__row">
											<div className="data-table__table__footer__row__left">
												<div className="data-table__table__pagination">
													<input className="data-table__table__pagination__page" value={currentPage} type="number" onChange={(e) => handleCurrnetInput(e)} min="1" max={meta?.totalPages} />
													<span className="data-table__table__pagination__page__meta"> of {meta?.totalPages || 1} pages </span>
													<button className="data-table__table__pagination__prev" disabled={currentPage === 1 || !meta?.totalPages} onClick={() => goToPrev()}><IconChevronDown /></button>
													<button className="data-table__table__pagination__next" disabled={currentPage === meta?.totalPages || !meta?.totalPages} onClick={() => goToNext()}><IconChevronDown /></button>
												</div>
											</div>
											<div className="data-table__table__footer__row__right">
												<div className="data-table__table__meta">
													Showing {getPageLabel(meta?.total, pageLimit, currentPage - 1)} of {meta?.total || 0} entries
												</div>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</div>

			<RenameFolderModal
				visible={isShowRenameFolderModal}
				close={hideRenameFolderModel}
				data={selectedRenameItem}
			/>

			<DeleteFolderModal
				visible={isShowDeleteFolderModal}
				close={hideDeleteFolderModal}
				id={selectedDeleteItem?.id}
			/>
		</>


	)

}
